import debounce from 'lodash/debounce';

class AppContacts {
	constructor(element, options = {}) {
		this.element = element;
		this.options = options;

		// Get initial data
		this.initial =
			(element.dataset.formAppContactsInitial
				? JSON.parse(element.dataset.formAppContactsInitial)
				: null) || [];

		// Find target field
		this.targetFieldName = element.dataset.formAppContacts;
		this.targetField = document.querySelector(`[name="${this.targetFieldName}"]`);

		if (!this.targetField) {
			return;
		}

		// Set up template
		// TODO: Handle additional fields in same group
		this.wrapper = element.closest('.ln-layout-content__inner');

		if (!this.wrapper) {
			return;
		}

		const title = this.wrapper.querySelector('.ln-form__group-title');

		if (title) {
			this.title = title.outerHTML;

			this.wrapper.removeChild(title);
		}

		const text = this.wrapper.querySelector('.ln-form__row');

		if (text) {
			this.text = text.outerHTML;

			this.wrapper.removeChild(text);
		}

		this.template = this.wrapper.innerHTML.replace(
			new RegExp(`data-form-app-contacts="${this.targetFieldName}"`, 'g'),
			''
		);

		// Set up initial contacts
		this.updateContacts();

		// Update contacts on change
		this.targetField.addEventListener(
			'change',
			debounce(() => {
				this.updateContacts();
			}, 100)
		);
	}

	createContact({ key, title } = {}) {
		const markup = this.template
			.replace(
				new RegExp(`_app_contacts_${this.targetFieldName}`, 'g'),
				`_app_contacts_${this.targetFieldName}_${key}`
			)
			.replace(/LABEL/g, title);

		return markup;
	}

	updateContacts() {
		const contacts = JSON.parse(this.targetField.value || '[]');

		this.wrapper.innerHTML = `${this.title}${this.text}`;

		contacts.forEach(contact => {
			const markup = this.createContact(contact);
			const node = document.createElement('div');

			node.innerHTML = markup;

			const initialData = this.initial.find(item => item.key === contact.key);

			if (initialData) {
				const select = node.querySelector(
					`[name="_app_contacts_${this.targetFieldName}_${contact.key}"]`
				);

				if (select) {
					select.value = initialData.value;
				}
			}

			this.wrapper.appendChild(node);

			if (this.options.initForm) {
				this.options.initForm(node);
			}
		});
	}
}

function initAppContacts(form, options) {
	const elements = form.querySelectorAll('[data-form-app-contacts]');

	elements.forEach(element => {
		new AppContacts(element, options);
	});
}

export { initAppContacts };
